import { invariant } from 'folio-common-utils';
import * as React from 'react';
import { type RootState, useSelector } from '../../../state';
import { selectors } from '../../../state/founding';
import { UserSigning } from './UserSigning';
import { UserWaiting } from './UserWaiting';
import { signingProgress } from './signingProgress/selector';

function selector(state: RootState) {
  const signers = selectors.signings(state);
  const formOwner = signers.find(
    signer => signer.id === state.editor.formOwner,
  );

  return {
    orgName: state.founding.foundingDetails?.name,
    formOwner,
    signingProgress: signingProgress(state),
  };
}

export const SignAllStep: React.FC = () => {
  const { formOwner, signingProgress } = useSelector(selector);

  if (formOwner == null) {
    return null;
  }

  invariant(
    signingProgress.stepName !== 'complete',
    'signing progress step name must not be "complete"',
  );

  const formOwnerSigning = signingProgress.signerUrls.find(
    signing => signing.id === formOwner.id,
  );

  // If the form owner should not sign this thing, or if the form owner has
  // already signed it, show "waiting for others" screen
  if (!formOwnerSigning || formOwnerSigning.signed) {
    return <UserWaiting />;
  }

  return (
    <UserSigning name={formOwner.name} signingUrl={formOwnerSigning.url} />
  );
};
